import { MARK_UNDERLINE, createDeserializeMdPlugin } from '@udecode/plate'

export default () =>
  createDeserializeMdPlugin({
    options: {
      elementRules: {},
      textRules: {}
    }
  })
